module.exports = __webpack_public_path__ + "img/logo@2x.43a91632.png";